export const IS_WEBVIEW_QUERY_KEY = 'webview'
